import React from 'react'
import { useSelector } from 'react-redux'
import { getPcrSelector } from '../../features/home/selectors'
import { getPatientDemographicsSelector } from '../../features/patientDemographics/selectors'
import Header from '../header/Header.component'
import './PCRHeader.component.css'
import { IPcrSummary } from '../../features/home/store/home.types'

const PCRHeader = () => {
  const pcr: IPcrSummary | null = useSelector(getPcrSelector)
  const patientDemographics = useSelector(getPatientDemographicsSelector)

  if (!pcr) {
    return <Header title='' />
  }

  const { age, firstName, lastName, ageUnit } = patientDemographics

  const getPCRTitle = () => {
    if (pcr) {
      let pdName = `${firstName} ${lastName}`

      if (pdName.length > 37) {
        pdName = pdName.substring(0, 35) + '...'
      }
      let ageValue = age || ''
      if (age && ageUnit) {
        let ageUnitLabel = ''

        switch (ageUnit?.id?.toString()) {
          case 'h':
            ageUnitLabel = 'h'
            break
          case 'd':
            ageUnitLabel = 'd'
            break
          case 'm':
            ageUnitLabel = 'mo'
            break
          case 'y':
            ageUnitLabel = 'yr'
            break
        }
        ageValue = `${age}${ageUnitLabel}`
      }
      return (
        <h6 className='name-header'>
          <b>
            {pdName && pdName.trim() ? `${pdName.trim()}` : ''}
            {pdName.trim() && ageValue ? ', ' : ''}
            {ageValue}
          </b>
        </h6>
      )
    } else {
      return ''
    }
  }

  return <Header isPHI title={getPCRTitle()} />
}

export default PCRHeader
